export const urlParamsToSelection = (searchParams) => {
  return {
    taskListFilter: searchParams.has("task_list")
      ? searchParams
          .get("task_list")
          .split(",")
          ?.map((id) => parseInt(id))
      : [],
    assigneeFilter: searchParams.has("assignee")
      ? searchParams
          .get("assignee")
          .split(",")
          ?.map((id) => parseInt(id))
      : [],
    dueDateFilter: searchParams.has("due_date") ? searchParams.get("due_date") : [],
    labelFilter: searchParams.has("label")
      ? searchParams
          .get("label")
          .split(",")
          ?.map((id) => parseInt(id))
      : [],
    completionDateFilter: searchParams.has("completion_date") ? searchParams.get("completion_date") : [],
    completedByFilter: searchParams.has("completed_by")
      ? searchParams
          .get("completed_by")
          .split(",")
          ?.map((id) => parseInt(id))
      : [],
  };
};
